/**
 * AUTO-GENERATED by scripts/generate-cvent-plan.mjs — DO NOT EDIT BY HAND.
 *
 * Source of truth: src/analytics/cvent/actions/*.json.
 * Regenerate with: pnpm attendee-activities:generate-plan
 */
import { Action, type AttendeeActivitiesActionProps } from '@cvent/analytics/Action';

/**
 * Props for the "question asked" Attendee Activities fact.
 *
 * Extends `AttendeeActivitiesActionProps`, which requires `objectId`. For this
 * fact the `objectId` mirrors `sessionId`.
 */
export interface QuestionAskedProps extends AttendeeActivitiesActionProps {
  /** Identifier of the Goldcast session the question was asked in. */
  sessionId: string;

  /** Identifier of the submitted question. */
  questionId: string;

  /** Whether the question was submitted anonymously. */
  isAnonymous?: boolean;
}

/**
 * `@cvent/analytics` Action model for the "question asked" fact.
 *
 * The `id` is the Attendee Activities `activity_type`. Routing is not set per action — the
 * singleton's `defaultDestinations` (`CVENT_ANALYTICS_DESTINATIONS`) routes
 * every fact, matching `../actions/question_asked.json`.
 *
 * @description Tracks when an attendee asks a question during a Goldcast session, publishing to the Cvent Attendee Activities pipeline to build a unified record of attendee engagement.
 * @trigger Fired when an attendee submits a question in the Q&A panel during a live or on-demand session.
 */
export default class QuestionAsked extends Action<QuestionAskedProps> {
  id = 'session.question_asked';
}
